module.exports = __webpack_public_path__ + "static/img/home-mobile.90ef115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-mobile.jpg
// module id = OIGg
// module chunks = 0